import React, { Component, Fragment } from 'react'
import { ResponsiveContext } from 'grommet'
import loadable from '@loadable/component'
// import Snowfall from 'react-snowfall'
import Measure from 'react-measure'
import { connect } from 'react-redux'
import {
  showTurntable,
  setTurntableSize,
  setChoices,
  changeKeyText,
  setResultSelected,
  // syncFirstChoicesList,
} from '../redux/homepage/actions'
import { setStartRotate } from '../redux/turntable/actions'
import Layout from '../layout/GeneralLayout'
import Turntable from '../component/Turntable'
import SEO from '../component/SEO'
import Inputs from '../component/Inputs'
import ToolTitle from '../component/Title'
import PickerWheelSharedImage from '../images/tools/Picker-Wheel.png'
// import withLocation from '../component/HOC/withLocation'
// import withFullScreen from '../component/HOC/withFullScreen'
import withWheelToolHOC from '../component/HOC/withWheelToolHOC'
import Footer from '../component/Footer'
import ToolType from '../utils/toolType'
import { isMobile } from 'react-device-detect'
import PageTitle from '../component/PageComponent/PageTitle'
// import { getShareLink } from '../redux/shareWheel/actions'
// import { rgba } from 'polished'
import { openAuthModal } from '../redux/auth/actions'
import AllResultsButton from '../component/Button/AllResultsButton'
import FullScreenButton from '../component/Button/FullScreenButton'
import {
  TurntableBox,
  BGContainer,
  ContainerTool,
  WheelWhiteBox,
  WheelBox,
  // InputBox,
  WheelPlaceholder,
} from '../component/PageComponent/Box'
import { RelativeBox } from '../component/Common'
import InputBox from '../component/PageComponent/InputBox'
import MiddleBox from '../component/PageComponent/MiddleBox'
import ArticleContent from '../component/Section/Content'
import SpinnerFullScreen from '../component/Spinner/SpinnerFullScreen'
import BackgroundAllResults from '../component/AllResults/BackgroundAllResults'
import ToolSettings from '../component/ToolSettings'
import Versioning from '../component/PageComponent/Versioning'
// import withGetShareLink from '../component/HOC/withGetShareLink'
// import { getPersistor } from '../utils/reduxPersistor'
import VolumeButton from '../component/Button/VolumeButton'
// import HideInputProvider from '../contextHook/hideInput'
import UnhideInputButton from '../component/Button/UnhideInputButton'
// import FloatingTitle from '../component/Title/FloatingTitle'
// import FloatingBox from '../component/PageComponent/FloatingBox'
import withProvider from '../component/HOC/withProvider'
import InputShield from '../component/PageComponent/InputShield'
import ShareModeButton from '../component/Button/ShareModeButton'
import { replaceCDN } from '../utils'
import SpinQuantity from '../component/PageComponent/SpinQuantity'
import { fontSizes } from '../component/ReactTurntable/TurntableFontSize'
import FullScreenLayout from '../layout/FullScreenLayout'

const Modal = loadable(() => import('../component/Modals/ResultModal'), {
  fallback: <SpinnerFullScreen caption="Please wait..." />,
})
const InputListModal = loadable(
  () => import('../component/Modals/InputListModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)
// const ToolSettings = loadable(() =>
//   pMinDelay(import('../component/ToolSettings'), 200),
// )
// const ArticleContent = loadable(() => import('../component/Section/Content'))
const LoadSaveModal = loadable(
  () => import('../component/Modals/LoadSaveModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)
const AllResults = loadable(() => import('../component/AllResults'), {
  fallback: (
    <BackgroundAllResults justify="center">Loading...</BackgroundAllResults>
  ),
})

const ModifyTitleModal = loadable(
  () => import('../component/Modals/ModifyTitleModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)
// const SpinnerFullScreen = loadable(() =>
//   import('../component/Spinner/SpinnerFullScreen'),
// )

const mapState = state => ({
  listModalDisplay: state.modal.listModalDisplay,
  loadSaveModalDisplay: state.modal.loadSaveModalDisplay,
  resultSelected: state.main.resultSelected,
  choices: state.main.choices,
  turnTable: state.main.turnTable,
  turnTableSize: state.main.turnTableSize,
  inputKeyText: state.main.inputKeyText,
  bgColor: state.settings.bgColor.color,
  savedChoicesList: state.main.savedChoicesList,
  // getShareLoading: state.async.getShareLoading,
  randomStart: state.settings.spinBehavior.randomStart,
  weightOn: state.main.weightOn,
  // tabsData: state.common.tabsData,
  bgImage: state.settings.bgImage,
  spinQuantity: state.settings.spinBehavior.spinQuantity,
  modifyTitleModal: state.modal.modifyTitleModal,
  // donorboxLoaded: state.common.donorboxLoaded,
})
const actions = {
  showTurntable,
  setTurntableSize,
  setChoices,
  changeKeyText,
  setResultSelected,
  // syncFirstChoicesList,
  // getShareLink,
  openAuthModal,
  setStartRotate,
}

class index extends Component {
  state = {
    bgColor: 'var(--bgPlaceholder)',
    turntableBoxSize: 300,
    modalPreloaded: false,
    allResultsOpen: false,
    bgImage: { on: false, src: null },
    spinQuantityEnabled: false,
  }

  checkFullyClaimed(fullChoices, filteredChoices) {
    return fullChoices.length !== 0 && filteredChoices.length === 0
  }

  componentDidMount() {
    this.setState({
      bgColor: this.props.bgColor,
      turntableBoxSize: this.props.turnTableSize,
      bgImage: this.props.bgImage,
      spinQuantityEnabled: this.props.spinQuantity, // need to use state because initial load will have persist issue
    })
    if (this.props.randomStart) {
      this.props.setStartRotate(2 * Math.PI * Math.random())
    }
    const fChoices = this.props.choices.filter(
      choice => choice.filtered === false,
    )
    const choices = []
    const weights = []
    const images = []
    for (let i = 0; i < fChoices.length; i++) {
      choices.push(fChoices[i].name)
      if (this.props.weightOn) {
        if (fChoices[i].weight === undefined) {
          weights.push(1)
        } else {
          weights.push(fChoices[i].weight)
        }
      }
      if (fChoices[i].data === undefined) {
        images.push(null)
      } else {
        images.push(fChoices[i].data)
      }
    }
    const isBlankWheel = this.checkFullyClaimed(this.props.choices, choices)
    const turnTable = (
      <Turntable
        page="main"
        choices={choices}
        weights={weights}
        images={images}
        size={this.props.turnTableSize}
        completed={(choice, index) =>
          this.props.setResultSelected(choice, index)
        }
        started={() => {
          if (!this.state.modalPreloaded) {
            Modal.preload()
            this.setState({ modalPreloaded: true })
          }
        }}
        fontSize={fontSizes.main.normal}
        isBlankWheel={isBlankWheel}
      />
    )
    this.props.showTurntable(turnTable)
    // this.setState({ loading: false })

    const inputsString = this.props.search.choices
    if (inputsString) {
      const inputsArray = inputsString.split(',')
      let inputs = []
      for (var i = 0; i < inputsArray.length; i++) {
        inputs.push({
          name: inputsArray[i],
          count: 0,
          filtered: false,
        })
      }
      this.props.setChoices(inputs.slice(0))
      this.props.changeKeyText()
    }

    // const shareId = this.props.search.id
    // if (shareId) {
    //   getPersistor().pause()
    //   const data = {
    //     sharePage: 'main',
    //     sharePath: shareId,
    //   }
    //   this.props.getShareLink(data).catch(error => {
    //     getPersistor().persist()
    //     toast.warning(error.error)
    //   })
    // }

    // setTimeout(
    //   this.setState({
    //     adsense1: (
    //       <ResponsiveContext.Consumer>
    //         {size => {
    //           return (
    //             <Adsense
    //               slot={AdSlot.TopTitle}
    //               height={size === "medium" ? "60px" : "90px"}
    //               width={size === "medium" ? "468px" : "728px"}
    //             />
    //           )
    //         }}
    //       </ResponsiveContext.Consumer>
    //     ),
    //     adsense2: (
    //       <Adsense slot={AdSlot.BottomTool} height="250px" width="300px" />
    //     ),
    //   }),
    //   500
    // )
  }

  componentDidUpdate(prevProps, prevState) {
    // only update chart if the data has changed
    // if (prevProps.choices.toString() !== this.props.choices.toString()) {
    // window.DonorBox = { widgetLinkClassName: "custom-dbox-popup" }
    if (prevState.bgColor !== this.props.bgColor) {
      this.setState({ bgColor: this.props.bgColor })
    }
    if (prevState.bgImage !== this.props.bgImage) {
      this.setState({ bgImage: this.props.bgImage })
    }
    if (prevState.spinQuantityEnabled !== this.props.spinQuantity) {
      this.setState({ spinQuantityEnabled: this.props.spinQuantity })
    }
    if (
      this.props.turnTableSize !== prevProps.turnTableSize &&
      this.props.turnTable !== null // only happen on initial render without local storage
    ) {
      this.props.showTurntable(null)
    }
    if (this.props.turnTable === null) {
      // var choices = this.props.choices.filter(
      //   (d, i) => this.props.filteredChoices.indexOf(i) === -1
      // )
      const fChoices = this.props.choices.filter(
        choice => choice.filtered === false,
      )
      const choices = []
      const weights = []
      const images = []
      for (let i = 0; i < fChoices.length; i++) {
        choices.push(fChoices[i].name)
        if (this.props.weightOn) {
          if (fChoices[i].weight === undefined) {
            weights.push(1)
          } else {
            weights.push(fChoices[i].weight)
          }
        }
        if (fChoices[i].data === undefined) {
          images.push(null)
        } else {
          images.push(fChoices[i].data)
        }
      }
      const isBlankWheel = this.checkFullyClaimed(this.props.choices, fChoices)
      if (this.props.turnTableSize !== prevProps.turnTableSize) {
        this.setState({ turntableBoxSize: this.props.turnTableSize })
      }
      let fontSize = fontSizes.main.normal
      if (this.props.handleFullScreen.active) fontSize += fontSizes.main.extra
      const turnTable = (
        <Turntable
          page="main"
          choices={choices}
          weights={weights}
          images={images}
          size={this.props.turnTableSize}
          completed={(choice, index) =>
            this.props.setResultSelected(choice, index)
          }
          started={() => {
            if (!this.state.modalPreloaded) {
              Modal.preload()
              this.setState({ modalPreloaded: true })
            }
          }}
          fontSize={fontSize}
          fullScreenActive={this.props.handleFullScreen.active}
          isBlankWheel={isBlankWheel}
        />
      )
      this.props.showTurntable(turnTable)
    }
  }

  // componentWillUnmount() {
  //   if (this.state.audios !== null) {
  //     this.state.audios.destroyAudios()
  //   }
  // }

  render() {
    const {
      resultSelected,
      turnTable,
      listModalDisplay,
      setTurntableSize,
      showTurntable,
      getShareLoading,
      loadSaveModalDisplay,
      handleFullScreen,
      handleHideInput,
      // tabsData,
      // bgImage,
      modifyTitleModal,
      // bgColor,
    } = this.props
    const {
      bgColor,
      turntableBoxSize,
      allResultsOpen,
      bgImage,
      spinQuantityEnabled,
    } = this.state
    return (
      <Layout>
        <ResponsiveContext.Consumer>
          {size => {
            return (
              <Fragment>
                {getShareLoading && (
                  <SpinnerFullScreen caption="Getting share data..." />
                )}

                <BGContainer
                  // width="120rem"
                  alignSelf="stretch"
                  justify="center"
                  align="stretch"
                  // margin={{ top: "1rem", bottom: "3rem" }}
                  bgColor={bgColor}
                >
                  {/* <Snowfall
                    snowflakeCount={size === 'medium' ? 60 : 200}
                    radius={[0.5, 5]}
                    speed={[1.0, 3.0]}
                    wind={[-0.5, 1.0]}
                  /> */}
                  {/* <Adsense
                      slot={AdSlot.TopTitle}
                      height="90px"
                      width="728px"
                    /> */}
                  {/* {this.state.adsense1} */}
                  {/* <Ezoic
                    align="stretch"
                    alignSelf="center"
                    margin={{ top: "1rem" }}
                    id={EzoicId.aboveTitle}
                  /> */}
                  <FullScreenLayout handle={handleFullScreen}>
                    {loadSaveModalDisplay && (
                      <LoadSaveModal type={loadSaveModalDisplay} page="main" />
                    )}
                    {resultSelected && <Modal result={resultSelected} />}
                    {listModalDisplay === ToolType.PICKER_WHEEL && (
                      <InputListModal size={size} toolType={listModalDisplay} />
                    )}
                    {modifyTitleModal && (
                      <ModifyTitleModal
                        page="main"
                        phTitle="Picker Wheel"
                        phDescription="Help you to make a random decision"
                      />
                    )}

                    <PageTitle
                      page="main"
                      title="Picker Wheel"
                      caption="Help you to make a random decision"
                      fullScreenActive={handleFullScreen.active}
                      bgColor={bgColor}
                    />
                    {/* <Ezoic
                    align="stretch"
                    alignSelf="center"
                    // margin={{ vertical: ".5rem" }}
                    id={EzoicId.aboveTitle}
                  /> */}
                    {/* <AdsBox adSlot={AdSlot.TopTitle} adType="horizontal" /> */}
                    {/* </Ezoic> */}
                    {/* <AdsBox
                    align="stretch"
                    alignSelf="center"
                    margin={{ vertical: "1rem" }}
                    adSlot={AdSlot.TopTitle}
                    adType="horizontal"
                  /> */}
                    <ContainerTool fullScreenActive={handleFullScreen.active}>
                      {/* <ContainerTool> */}
                      <WheelWhiteBox
                        background="baseBackground"
                        align="center"
                        fullScreenActive={handleFullScreen.active}
                        bgImage={!bgImage.on ? null : replaceCDN(bgImage.src)}
                        // round={{ size: '2rem', corner: 'bottom' }}
                        // round="2rem"
                      >
                        <WheelBox
                          // width="120rem"
                          direction="row"
                          wrap={true}
                          justify="center"
                          fullScreenActive={handleFullScreen.active}
                        >
                          {typeof window === 'undefined' ? ( // for ssr rendering
                            <TurntableBox
                              alignSelf="center"
                              align="center"
                              justify="center"
                              flex="grow"
                              // minHeight="300px"
                            >
                              <WheelPlaceholder size={600} />
                              <Turntable page="main" choices={[]} size={300} />
                            </TurntableBox>
                          ) : (
                            <Measure
                              bounds
                              onResize={contentRect => {
                                const width = contentRect.bounds.width
                                // const height = contentRect.bounds.height
                                const maxWidth = handleFullScreen.active
                                  ? 1200
                                  : 600
                                if (width > maxWidth) {
                                  if (turntableBoxSize !== maxWidth) {
                                    setTurntableSize(maxWidth)
                                  }
                                } else if (width !== 0) {
                                  setTurntableSize(width)
                                } else if (width === 0) {
                                  const tempWidth = isMobile ? 300 : maxWidth
                                  setTurntableSize(tempWidth)
                                  showTurntable(null)
                                  // setTimeout(() => , 50)
                                }
                                // this.setState({ dimensions: contentRect.bounds })
                              }}
                            >
                              {({ measureRef }) => (
                                <TurntableBox
                                  ref={measureRef}
                                  alignSelf="center"
                                  // basis={size === "small" ? "full" : "1/2"}
                                  align="center"
                                  justify="center"
                                  flex="grow"
                                  fullScreenActive={handleFullScreen.active}
                                  minHeight={
                                    turntableBoxSize
                                      ? `${turntableBoxSize}px`
                                      : '300px'
                                  }
                                >
                                  {/* during run time wheelplaceholder not update initial load */}
                                  <WheelPlaceholder size={turntableBoxSize} />
                                  {turnTable}
                                  {allResultsOpen && (
                                    <AllResults
                                      page="main"
                                      fullScreenActive={handleFullScreen.active}
                                      close={() =>
                                        this.setState({
                                          allResultsOpen: false,
                                        })
                                      }
                                    />
                                  )}
                                  {spinQuantityEnabled && <SpinQuantity />}
                                </TurntableBox>
                              )}
                            </Measure>
                          )}
                          {/* )} */}
                          {/* {!handleFullScreen.active && ( */}
                          <InputBox
                            // gap="1rem"
                            align="center"
                            justify="center"
                            flex="shrink"
                            fullScreenActive={handleFullScreen.active}
                          >
                            {/* <ToolTitle page="main" /> */}
                            <RelativeBox>
                              <Inputs />
                              {/* {tabsData.length > 1 && <WheelTabs page="main" />} */}
                              {handleHideInput.showShield && (
                                <InputShield page="main" />
                              )}
                            </RelativeBox>
                          </InputBox>
                          {/* )} */}
                        </WheelBox>
                        {/* <FloatingBox fullScreenActive={handleFullScreen.active}>
                          <FloatingTitle
                            page="main"
                            fullScreenActive={handleFullScreen.active}
                          />
                        </FloatingBox> */}
                        {!handleFullScreen.active &&
                          !handleHideInput.shareModeActive && (
                            <UnhideInputButton />
                          )}
                        {/* hiding logic used inside component for animation */}
                        {!handleFullScreen.active &&
                          handleHideInput.hiding &&
                          handleHideInput.shareModeActive && (
                            <ShareModeButton page="main" />
                          )}
                        <VolumeButton />
                        <AllResultsButton
                          openBox={() => {
                            this.setState({ allResultsOpen: !allResultsOpen })
                          }}
                          isOpened={allResultsOpen}
                        />
                        <FullScreenButton handleFullScreen={handleFullScreen} />
                      </WheelWhiteBox>
                    </ContainerTool>
                  </FullScreenLayout>
                  <ContainerTool
                    fullScreenActive={false}
                    id="ToolSettingsSection"
                    // margin={{ bottom: '3.5rem' }}
                  >
                    <MiddleBox />
                    <ToolSettings size={size} page="main"></ToolSettings>
                    <Versioning size={size} />
                  </ContainerTool>

                  {/* <AdsBox
                    alignSelf="center"
                    margin={{ top: "2rem" }}
                    adSlot={AdSlot.BottomTool}
                    adType="square"
                  /> */}
                  {/* <AdsBox
                    align="stretch"
                    minHeight="250px"
                    minWidth="300px"
                    alignSelf="center"
                    margin={{ top: "2rem" }}
                  >
                    <Adsense
                      slot={AdSlot.BottomTool}
                      height="250px"
                      width="300px"
                    />
                    {/* {this.state.adsense2} */}
                  {/* </AdsBox>  */}
                </BGContainer>

                {/* <FeedbackDonateSection size={size} /> */}
                {/* <Box //separator
                  background="primary"
                  alignSelf="stretch"
                  basis="1"
                  pad={{ vertical: "1.5rem" }}
                  align="stretch"
                  direction={size === "medium" ? "column" : "row"}
                  justify="center"
                  gap="1.5rem"
                >
                  <SubSection
                    title="Have Idea to Improve Picker Wheel?"
                    label="Leave Feedback"
                    link="/feedback/"
                    color="primary02"
                    size={size}
                  >
                    If you have a question, find out a bug, have feedback or
                    know how to make the picker wheel works better, please
                    provide us the information. Your response is valuable for
                    us.
                  </SubSection>
                  <SubSection
                    title="Consider to Make a Contribution?"
                    label="Contribute"
                    link="https://donorbox.org/picker-wheel-contributions?amount=10"
                    color="secondary"
                    size={size}
                    external
                    clName="custom-dbox-popup"
                  >
                    If you're finding Picker Wheel useful, your funding support
                    to help keeping the service going are most welcome. Your
                    contribution means a lot to us and the Picker Wheel app.
                  </SubSection>
                </Box> */}
                {/* <ContentBox
                  basis="1"
                  pad={{
                    vertical: "5rem",
                    horizontal: "1.5rem",
                  }}
                  flex={true}
                >
                  <PickerWheelManual size={size} file="PickerWheelManual" />
                </ContentBox> */}
                {/* <OuterContentBox
                  pad={{
                    top: "5rem",
                    bottom: size === "medium" ? "1rem" : "5rem",
                    horizontal: "1.5rem",
                  }}
                  flex={true}
                  direction={size === "medium" ? "column" : "row"}
                  align={size === "medium" ? "center" : "start"}
                  justify="between"
                  gap={size === "medium" ? "1rem" : "2rem"}
                >
                  <ContentBox basis="1">
                    <PickerWheelManual size={size} file="PickerWheelManual" />
                  </ContentBox>
                  <Ezoic id={EzoicId.topSidebar} />
                </OuterContentBox> */}
                <ArticleContent content="PickerWheelManual" />
                <Footer />
              </Fragment>
            )
          }}
        </ResponsiveContext.Consumer>
      </Layout>
    )
  }
}

// export default connect(
//   mapState,
//   actions,
// )(withLocation(withFullScreen(withGetShareLink(index))))

export default connect(
  mapState,
  actions,
)(withProvider(withWheelToolHOC(index, 'main')))

export const Head = () => (
  <SEO
    keywords={[
      'picker wheel',
      'random picker wheel',
      'random name picker wheel',
      'name picker wheel',
      'random name picker',
      'wheel spin',
      'pickerwheel',
      'spin wheel',
      'wheel decide',
      'wheel of names',
      'spin the wheel',
      'random name picker',
      'wheel spinner',
      'random wheel',
      'randomizer wheel',
      'spinner wheel',
      'spinning wheel',
      'random picker',
    ]}
    image={PickerWheelSharedImage}
    homepage={true}
  />
)
